export class Validation {
    private validators: FormValidation[] = [];

    constructor() {
        $(".ui.form").each((i, e) => {
            this.validators.push(new FormValidation(e));
        });
    }

    public attach() {
        for (const v of this.validators) {
            v.attach();
        }
    }
}

interface IValidation {
    type: string;
    prompt: string;
}

export class FormValidation {
    private readonly root: Element;
    private fields = {};

    private invalidFields = [];
    constructor(root: Element) {
        this.root = root;

        $("input, select", root).each((i, e) => {
            if ($(e).hasClass("input-validation-error")) {
                this.invalidFields.push(e.id);
            }

            if (e.getAttribute("data-val") === "true") {
                const rules: IValidation[] = [];

                const required = e.getAttribute("data-val-required");
                if (required) {
                    rules.push({
                        prompt: required,
                        type: "empty",
                    });
                }
                const num = e.getAttribute("data-val-number");
                if (num) {
                    rules.push({
                        prompt: num,
                        type: "number",
                    });
                }

                const equalTo = e.getAttribute("data-val-equalto");
                if (equalTo) {
                    const other = e.getAttribute("data-val-equalto-other");
                    rules.push({
                        prompt: equalTo,
                        type: `match[${other.substr(2)}]`,
                    });
                }

                const range = e.getAttribute("data-val-range");
                if (range) {
                    const min = e.getAttribute("data-val-range-min");
                    const max = e.getAttribute("data-val-range-max");
                    rules.push({
                        prompt: range,
                        type: `integer[${min}..${max}]`,
                    });
                }
                this.fields[e.id] = {
                    identifier: e.id,
                    rules,
                };
            }
        });
    }

    public attach() {
        $(this.root).form({
            fields: this.fields,
        });
    }
}
